import axios from "axios";
import AuthService from "./AuthService";

class TelefoneService {
    constructor() {
        this.apiUrl = process.env.REACT_APP_API_URL || "https://portalrelacionamentoapi.dev-gam.com";
    }

    async atualizarTelefone(cdCliente, cdTelefone, nrTelefone, idTelefone) {
        try {
            if (!AuthService.getToken()) {
                await AuthService.login();
            }

            // Remove formatação do telefone (apenas números)
            const telefoneLimpo = nrTelefone.replace(/\D/g, '');

            const response = await axios.post(
                `${this.apiUrl}/cliente/telefone/${cdCliente}/${cdTelefone}/${telefoneLimpo}/${idTelefone}`,
                {},
                {
                    headers: {
                        Authorization: `Bearer ${AuthService.getActiveToken()}`,
                        "Content-Type": "application/json",
                    },
                }
            );

            return response.data;
        } catch (error) {
            console.error("Erro ao atualizar telefone:", error);
            throw new Error("Erro ao atualizar telefone.");
        }
    }
}

export default new TelefoneService();

